<template>
  <b-col md="12" sm="12">
    <b-card no-body >
      <b-card-body class="p-12">
        <h1 tabindex="0">{{ form.titulo }}</h1>
        <b-row>
          <b-col cols="12">
            <div v-html="form.descricao" tabindex="0"></div>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body >
      <b-card-body class="p-12">
        <b-row>
          <b-col cols="12">
            <div v-html="form.mocao" tabindex="0"></div>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row v-if="form.situacao == 'E' && permiteVotar">
          <b-col md="4">
            <b-button block variant="success" @click="loadModalAprovacao()">
              <i class="fa fa-check"></i>&nbsp;
              <span v-if="load">Aprovar</span>
              <span v-if="!load">Visualizar Aprovações</span>
              <span class="badge badge-light">{{ form.totalAprovado }}</span>
            </b-button>
          </b-col>
          <b-col md="4">
            <b-button block variant="danger" @click="loadModalRejeicao()">
              <i class="fa fa-times"></i>&nbsp;
              <span v-if="load">Rejeitar</span>
              <span v-if="!load">Visualizar Rejeições</span>
              <span class="badge badge-light">{{ form.totalRejeitado }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
    <b-card no-body >
      <b-row>
        <b-col class="col-sm-12">
          <div style="background-color: #FAAF40; padding-top: 5px; padding-bottom: 1px;">
            <p tabindex="0" style="font-size: 16px">&nbsp;<strong>Mensagens</strong></p>
          </div>
          <b-card style="height: 300px; overflow: auto;">
            <ul v-if="form.comentarios.length > 0">
              <li v-for="comentario in form.comentarios" :key="comentario.id">
                <strong>{{ comentario.usuario }} - {{ comentario.created_at }}</strong><br>
                <div class="p-3 mb-2 bg-primary text-white" style="border-radius: 10px; width: 50%;">{{
                  comentario.descricao }}</div>
              </li>
            </ul>
            <ul v-else>
              <li>
                <i tabindex="0">Nenhuma mensagem.</i>
              </li>
            </ul>
            <b-row v-if="perfil.is_admin_conferencia || perfil.tipo_perfil == 'DE' || perfil.tipo_perfil == 'CN'">
              <b-col cols="10">
                <b-form-textarea placeholder="Digite sua mensagem" tabindex="0" id="textarea" rows="3"
                  v-model="comentario"></b-form-textarea>
              </b-col>
              <b-col cols="2">
                <b-button variant="success" size="lg" @click="enviarComentario()">
                  <i class="fa fa-paper-plane-o" aria-hidden="true"></i>&nbsp;&nbsp;<span>Enviar</span>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-card>
    <b-card no-body >
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="4">
            <b-button block variant="secondary" @click="navigate('/mocao')">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>

    <b-modal :title="votacao ? 'Aprovação' : 'Visualizar Aprovação'" size="lg" v-model="modalAprovacao" @ok="cancelar()"
      ok-only>
      <b-card-body>
        <b-row>
          <b-col cols="12" style="text-align: center">
            <h5 tabindex="0"><strong>{{ form.titulo }}</strong></h5>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="12">
            <div tabindex="0" v-html="form.mocao" />
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="12" style="text-align: center">
            <h5 tabindex="0"><strong>Aprovada Por</strong></h5>
          </b-col>
        </b-row>
        <hr>
        <b-form>
          <p><strong> Total Aprovações: {{ form.totalAprovado }} </strong></p>
          <span v-if="avaliacoes.data !== undefined">
            <b-row>
              <b-col tabindex="0" md="12" sm="12">
                <ul>
                  <li v-for="(avaliacao) in avaliacoes.data" :key="avaliacao.id">
                    {{ avaliacao.nome_social ? avaliacao.nome_social : avaliacao.usuario }} - {{ avaliacao.created_at }}
                  </li>
                </ul>
              </b-col>
            </b-row>
          </span>
          <span tabindex="0" v-else><i>Nenhuma votação registrada</i></span>
          <pagination tabindex="0" v-show="avaliacoes.data !== undefined" :totalPorPagina="5"
            :resource="resourceAprovacao" :filtros="filtros"></pagination>
          <hr>
          <b-row v-if="load">
            <b-col md="12" sm="12">
              <p tabindex="0" style="text-align: center"><strong>Deseja aprovar essa moção?</strong></p><br>
              <p tabindex="0" style="text-align: center">Após aprovar esta moção não será possível rejeitá-la.</p><br>
            </b-col>
            <b-col offset="2" md="4" sm="4">
              <b-button block variant="success" @click="aprovar()" :disabled="loading">
                <i class="fa fa-check"></i>&nbsp;&nbsp;<span>Aprovar</span>
              </b-button>
            </b-col>
            <b-col md="4" sm="4">
              <b-button block variant="secondary" @click="cancelar()">
                <span>Cancelar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>

    <b-modal :title="votacao ? 'Rejeição' : 'Visualizar Rejeição'" size="lg" v-model="modalRejeicao" @ok="cancelar()"
      ok-only>
      <b-card-body>
        <b-row>
          <b-col cols="12" style="text-align: center">
            <h5 tabindex="0"><strong>{{ form.titulo }}</strong></h5>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="12">
            <div v-html="form.mocao" tabindex="0" />
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col cols="12" style="text-align: center">
            <h5 tabindex="0"><strong>Rejeitada Por</strong></h5>
          </b-col>
        </b-row>
        <hr>
        <b-form>
          <p><strong> Total Rejeições: {{ form.totalRejeitado }} </strong></p>

          <span v-if="avaliacoes.data !== undefined">
            <b-row>
              <b-col tabindex="0" md="12" sm="12">
                <ul>
                  <li v-for="(avaliacao) in avaliacoes.data" :key="avaliacao.id">
                    {{ avaliacao.nome_social ? avaliacao.nome_social : avaliacao.usuario }} / {{ avaliacao.uf }} - {{
                      avaliacao.created_at }}
                  </li>
                </ul>
              </b-col>
            </b-row>
          </span>
          <span tabindex="0" v-else><i>Nenhuma votação registrada</i></span>
          <pagination tabindex="0" v-show="avaliacoes.data !== undefined" :totalPorPagina="5" :resource="resourceRejeicao"
            :filtros="filtros"></pagination>
          <hr>
          <b-row v-if="load">
            <b-col md="12" sm="12">
              <p tabindex="0" style="text-align: center"><strong>Deseja rejeitar essa moção?</strong></p><br>
              <p tabindex="0" style="text-align: center">Após rejeitar esta moção não será possível aprova-la.</p><br>
            </b-col>
            <b-col offset="2" md="4" sm="4">
              <b-button block variant="danger" @click="rejeitar()" :disabled="loading">
                <i class="fa fa-times"></i>&nbsp;&nbsp;<span>Rejeitar</span>
              </b-button>
            </b-col>
            <b-col md="4" sm="4">
              <b-button block variant="secondary" @click="cancelar()">
                <span>Cancelar</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>
    <b-modal title="Incluir Comentários" size="lg" cancel-title="Cancelar" v-model="modalComentario"
      @ok="enviarComentario()">
      <b-card-body>
        <b-form>
          <b-row>
            <b-col cols="12">
              <h3 tabindex="0" style="color: #339966; margin-bottom: 20px; font-weight: bold; text-align: center">Insira
                aqui seu Comentário</h3>
            </b-col>
          </b-row>
          <b-row>
            <b-col tabindex="0" cols="2">
              <strong>Comentário:</strong>
            </b-col>
            <b-col cols="10">
              <b-form-textarea tabindex="0" id="textarea" rows="8" v-model="comentario"></b-form-textarea>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-modal>

  </b-col>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'
import { eventType } from '@/components/shared/eventType'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    Pagination,
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  created() {
    this.loadMocao(this.$route.params.id)
  },
  data() {
    return {
      loading: false,
      form: {
        id: '',
        titulo: '',
        descricao: '',
        mocao: '',
        totalAprovado: 0,
        totalReprovado: 0,
        avaliacoes: {},
        comentarios: []
      },
      votacao: true,
      modalAprovacao: false,
      modalRejeicao: false,
      resourceAprovacao: '',
      resourceRejeicao: '',
      filtros: {
        aprovado: null
      },
      load: false,
      permiteVotar: false,
      propostaAtual: null,
      modalComentario: false,
      textoAtualSugestao: '',
      sugestaoEdicao: '',
      comentario: '',
      resourceSugestao: '',
      resourceComentario: '',
      modalSugestaoEdicao: false,
      usuarioAtual: 0,
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false
    }
  },
  computed: {
    avaliacoes() {
      return this.$store.state.pagination.getList
    },
    exclusoes() {
      return this.$store.state.pagination.getList
    },
    perfil() {
      return this.$store.state.perfil.perfil
    },
    comentarios() {
      return this.$store.state.pagination.getList
    },
    isValid() {
      return !this.$v.form.$anyError
    },
    isValidSelection() {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  methods: {
    loadModalComentarios() {
      this.modalComentario = true
      this.comentario = ''
    },
    loadModalAprovacao() {
      this.resourceAprovacao = 'mocao/' + this.$route.params.id + '/avaliacao'
      this.filtros.aprovado = true
      this.modalAprovacao = true
    },
    loadModalRejeicao() {
      this.resourceRejeicao = 'mocao/' + this.$route.params.id + '/avaliacao'
      this.filtros.aprovado = false
      this.modalRejeicao = true
    },
    loadMocao(id) {
      Vue.http.get('api/mocao/contribuicao/' + id).then(response => {
        let data = response.body.data
        this.form.id = data.id
        this.form.titulo = data.titulo
        this.form.descricao = data.descricao
        this.form.mocao = data.mocao
        this.form.comentarios = data.comentarios
        this.form.totalAprovado = data.totalAprovado
        this.form.totalRejeitado = data.totalRejeitado
        this.form.situacao = data.situacao
        if (data.perfil_acao) {
          if (data.perfil_acao.votacao) {
            this.permiteVotar = true
          }
        }
        if (!data.avaliacao) {
          this.load = true
        } else {
          this.load = false
        }
      })
    },
    loadComentarios(id) {
      console.log(id)
      Vue.http.get('api/mocao/' + id + '/comentario').then(response => {
        let data = response.body.data.data
        this.form.comentarios = data
      })
    },
    enviarComentario() {

      if (this.comentario == '' || this.comentario == null) {
        miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
        miniToastr.error('Campo mensagem e obrigatório!', 'Alerta', 5000)
        return false
      }

      this.$bvModal.msgBoxConfirm('Confirma o envio do comentário?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          let data = {
            descricao: this.comentario
          }

          this.loading = true
          Vue.http.post('api/mocao/' + this.form.id + '/comentario', data).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.modalComentario = false
              this.comentario = ''
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.loading = false
            this.loadComentarios(this.form.id)
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    aprovar() {
      this.$bvModal.msgBoxConfirm('Confirma a aprovação?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.put('api/mocao/' + this.$route.params.id + '/aprovada').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.loading = false
            this.load = false
            this.cancelar()
            this.loadMocao(this.$route.params.id)
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    rejeitar() {
      this.$bvModal.msgBoxConfirm('Confirma a rejeição?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.loading = true
          Vue.http.put('api/mocao/' + this.$route.params.id + '/rejeitada').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', { 'class': 'fa fa-check' })
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            } else {
              miniToastr.setIcon('error', 'i', { 'class': 'fa fa-warning' })
              miniToastr.error(response.body.msg, 'Alerta', 5000)
            }
            this.loading = false
            this.load = false
            this.loadMocao(this.$route.params.id)
            this.cancelar()
          }).catch(e => {
            console.log('Servidor está fora! ' + e)
          })
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    cancelar() {
      this.modalAprovacao = false
      this.modalRejeicao = false
    },
    setarFiltros(filtros) {
      eventType.$emit('app', filtros)
    },
    can(permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    navigate(route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/mocao/MocaoConsulta.vue